export enum TabUtilityType {
    Text = 'text',
    Icon = 'icon',
    Footer = 'footer',
    FooterUtilities = 'footerUtilities',
    SocialFooterUtility = 'socialFooterUtility',
    FloatingTab = 'floatingTab'
}